import React from 'react';
import styles from './index.module.scss';
import no_record from '../../../static/images_cso/no_record.png';

class NoRecord extends React.PureComponent {

    render() {
        return (
            <div className={styles.no_record_content}>
                <div className={styles.no_record}>
                    <img src={no_record} alt="" />
                </div>
                {
                    this.props.children &&
                    <div className={styles.children}>
                        {this.props.children}
                    </div>
                }
            </div>
        )
    }

}

export default NoRecord;